export default __webpack_public_path__ + "static/doctorPlaceholder-27fdc7216a2867fb3e13ad822718e79e.jpg";